import { ALEXA_RANGE, MONTHLY_SALES, CATEGORI_MATCH } from "../../utils/shop.utils"
import store from '../../../store'

const detectRange = (number, range) => {
    const rangeIndex = range.findIndex(el => number >= el.start && number <= el.end)
    return rangeIndex
}
const useMatchingScore = () => {
    const monthlySalesMatch = (myData, cardData) => {
        if(!myData || !cardData) {
            return
        }
        const mySalesRangeIndex = detectRange(myData, MONTHLY_SALES)
        const cardSalesRangeindex = detectRange(cardData, MONTHLY_SALES)
        let diff = cardSalesRangeindex - mySalesRangeIndex
        if(mySalesRangeIndex === 0 || cardSalesRangeindex === 0) {
            return 0
        }
        if(mySalesRangeIndex === 1) {
            if(diff === 0) {
                return 20
            }
            if(diff === 1) {
                return 10
            }
            return 0
        }   
        if(cardSalesRangeindex === MONTHLY_SALES.length - 1 || mySalesRangeIndex === MONTHLY_SALES.length - 1) {
            diff = Math.abs(diff)
            if(diff === 0) {
                return 20
            }
            if(diff <= 2) {
                return 10
            }
            return 0
        }
        switch(diff) {
            case 0:
                return 20
            case 1:
            case -1:
                return 10
            default:
                return 0
        }
    }
    const alexaRankMatch = (myData, cardData) => {
        if(!myData || !cardData) {
            return
        }
        const myRankRangeIndex = detectRange(myData, ALEXA_RANGE)
        const cardRankRangeIndex = detectRange(cardData, ALEXA_RANGE)
        let diff = cardRankRangeIndex - myRankRangeIndex
        if(myRankRangeIndex === 0 || cardRankRangeIndex === 0) {
            return 0
        }
        if(myRankRangeIndex === 1) {
            if(diff <= 1) {
                return 30
            }
            if(diff === 2) {
                return 15
            }
            return 0
        }
        if(cardRankRangeIndex === ALEXA_RANGE.length - 1) {
            diff = Math.abs(diff)
            if(diff <= 1) {
                return 30
            }
            if(diff === 2) {
                return 15
            }
            return 0
        }
        switch(diff) {
            case -1:
            case 0:
                return 30
            case 1:
                return 15
            case -2:
                return 15
            default:
                return 0
        }
    }
    const categoryMatch = (myCategory, cardCategory) => {
        if(!myCategory || !cardCategory) {
            return
        }
        const matchCategoryObject = CATEGORI_MATCH.find(el => el.category === myCategory.toLowerCase())

        if(!matchCategoryObject) return 0

        if(matchCategoryObject.moreRelevant.includes(cardCategory)) {
            return 50
        }
        if(matchCategoryObject.relevant.includes(cardCategory)) {
            return 25
        }
        return 0
    }

    return {
        monthlySalesMatch,
        alexaRankMatch,
        categoryMatch
    }
}

export default useMatchingScore